export default "__VITE_ASSET__3e29df8b__"